import { datadogRum } from '@datadog/browser-rum'

const TRIBES = {
  Engage: 'engage',
  Fulfilment: 'fulfilment',
  Pricing: 'pricing',
  StaffExperience: 'staffexperience',
  Unknown: 'unknown',
}

const TEAMS = {
  Journey: 'journey',
  ProductDataManagement: 'product-data-management',
  OrderExperience: 'order-experience',
  OffersVouchers: 'offers-vouchers',
  Compass: 'compass',
  Dynamics: 'dynamics',
  CheckoutPayment: 'checkout-payment',
  SellerExperience: 'seller-experience',
  OpsCore: 'ops-core',
  Unknown: 'unknown',
}

const TEAM_TRIBE_MAP = {
  [TEAMS.Journey]: TRIBES.Engage,
  [TEAMS.ProductDataManagement]: TRIBES.StaffExperience,
  [TEAMS.OrderExperience]: TRIBES.Fulfilment,
  [TEAMS.OffersVouchers]: TRIBES.Pricing,
  [TEAMS.Compass]: TRIBES.Engage,
  [TEAMS.Dynamics]: TRIBES.Engage,
  [TEAMS.CheckoutPayment]: TRIBES.Pricing,
  [TEAMS.SellerExperience]: TRIBES.Fulfilment,
  [TEAMS.OpsCore]: TRIBES.StaffExperience,
  [TEAMS.Unknown]: TRIBES.Unknown,
}

const ROUTE_GROUPS = {
  [TEAMS.Journey]: [
    '/marketing/blog',
    '/marketing/pages',
    '/marketing/web-banners',
    '/marketing/swa-banners',
    '/marketing/scan-campaigns',
    '/marketing/campaign-labels',
    '/app-home/banner-upload',
    '/qc/order-management',
    '/qc/orders',
    '/settings/customer-tags',
    '/settings/themes',
    '/settings/seo',
    '/settings/search-configuration',
  ],
  [TEAMS.ProductDataManagement]: [
    '/preorders/preorder-campaigns',
    '/preorders/define-festive-campaigns',
    '/catalogue/dashboard',
    '/catalogue/categories/tree-view',
    '/catalogue/categories',
    '/catalogue/brands',
    '/catalogue/products',
    '/catalogue/configurations',
    '/catalogue/product-cache-clear',
    '/catalogue/batch-uploads-status-tracker',
    '/catalogue/scheduled-batch-uploads',
    '/catalogue/sku-meta-upload',
    '/catalogue/tags',
    '/catalogue/substitution-groups',
    '/catalogue/stock-override',
    '/marketing/blog',
    '/marketing/pages',
    '/marketing/web-banners',
    '/marketing/campaign-labels',
    '/marketing/recommender',
    '/recipe/featured-recipes',
    '/recipe/batch-upload',
    '/media-monetization/media-allcampaigns',
    '/media-monetization/media-allcampaigns/media-campaign-detail',
    '/media-monetization/media-allcampaigns/media-adset',
    '/media-monetization/media-allcampaigns/media-adset-detail',
    '/media-monetization/media-allcampaigns/media-adset-offsite',
    '/media-monetization/media-storelist',
    '/media-monetization/media-storelist/media-assetlist',
    '/media-monetization/media-storelist/media-spotallocation',
    '/media-monetization/media-packagemanagement',
    '/media-monetization/media-packagemanagement/media-package-inventory',
    '/media-monetization/media-packagemanagement/media-package-detail',
    '/media-monetization/media-assetmanagement',
    '/media-monetization/media-assetmanagement/media-asset-detail',
    '/media-monetization/media-creativemanagement',
    '/media-monetization/media-creativemanagement/media-creative-detail',
    '/media-monetization/media-creativemanagement/media-creative-group-list',
    '/media-monetization/media-creativemanagement/media-creative-group-ad-list',
    '/media-monetization/media-creativemanagement/media-add-creative',
  ],
  [TEAMS.OrderExperience]: [
    '/operations/dashboard',
    '/operations/zone-picking-queue',
    '/operations/delivery-orders',
    '/operations/rack-management',
    '/operations/disputes',
    '/operations/returns',
    '/operations/pickers',
    '/operations/pickers-today',
    '/operations/timeslot-blocking',
    '/operations/bulk-operations',
    '/operations/delivery-orders/file-for-return',
    '/operations/capacity-planning',
    '/operations/capacity-planning/today',
    '/operations/slot-charges',
    '/customer-support/delivery-orders/order-log',
    '/customer-support/sale-orders',
    '/customer-support/delivery-orders/file-for-return',
    '/customer-support/order/order-return',
    '/customer-support/cleanup',
    '/settings/delivery-area',
    '/settings/slots',
    '/settings/logistics-configuration',
    '/settings/order-config',
  ],
  [TEAMS.OffersVouchers]: [
    '/catalogue/batch-upload-jobs',
    '/catalogue/offer-sku-limit',
    '/marketing/offers/pay-via-fp-app',
    '/marketing/offers/pin-wallet',
    '/marketing/offers',
    '/marketing/scan-rewards',
    '/marketing/search-campaigns',
    '/marketing/voucher-center-campaigns/new',
    '/marketing/voucher-center-campaigns/configuration',
    '/marketing/voucher-center-campaigns',
  ],
  [TEAMS.Compass]: [
    '/rewards/categories',
    '/rewards/carousels',
    '/rewards/maintenance',
    '/rewards/partners',
    '/rewards/stores',
    '/rewards/promotions',
    '/rewards/catalogue',
    '/rewards/merchants',
    '/rewards/devices',
    '/rewards/challenges',
    '/marketing/lucky-draws',
    '/app-home/tiles-dressup',
    '/app-home/splash-dressup',
    '/app-home/dynamic-layout',
    '/app-home/card-content',
    '/app-home/popup',
    '/app-home/whitelist-domain',
    '/omni-journey/vouchers',
    '/omni-journey/scratch-cards',
    '/omni-journey/scan-to-win',
  ],
  [TEAMS.Dynamics]: [
    '/customer-support/dashboard',
    '/customer-support/customers',
    '/customer-support/fpg-staff',
    '/customer-support/payments',
    '/marketing/games',
  ],
  [TEAMS.CheckoutPayment]: [
    '/gift-card/design-codes',
    '/gift-card/print-orders',
    '/gift-card/sales-orders',
    '/customer-support/egifting-orders',
    '/customer-support/egifting-orders-pending-bank-approval',
    '/customer-support/gifting-entities',
    '/marketing/evouchers',
    '/marketing/search-evoucher',
    '/marketing/evoucher-details',
    '/marketing/evouchers',
  ],
  [TEAMS.SellerExperience]: ['/marketplace/sellers'],
  [TEAMS.OpsCore]: [
    '/signUp',
    '/login',
    '/forgot-password',
    '/user/logout',
    '/verify',
    '/account-created',
    '/payment-response',
    '/hr/designations',
    '/hr/roles',
    '/hr/designation-roles',
    '/hr/employees',
    '/hr/attendance-summary',
    '/settings/extensions',
    '/settings/users',
    '/settings/stores',
    '/settings/analytics',
    '/settings/mobile-apps',
    '/settings/payment-configuration',
    '/settings/communication-configuration',
    '/settings/basic-information',
    '/settings/contact-details',
    '/settings/extensions',
    '/settings/notifications',
    '/user/change-password',
    '/user/account-balance',
    '/user/leave-management',
    '/user/my-leaves',
    '/user/leave-summary',
    '/admin/action-trail',
    '/admin/preorder',
    '/admin/sng-actions',
    '/in-store-preorder/offline',
  ],
}

const createTeamConfig = (team) => ({
  team,
  tribe: TEAM_TRIBE_MAP[team],
})

const TEAM_ROUTING_CONFIG = (() => {
  const config = {}

  Object.entries(ROUTE_GROUPS).forEach(([team, routes]) => {
    routes.forEach((route) => {
      config[route] = createTeamConfig(team)
    })
  })

  return config
})()

export const getTeamForRoute = (path) => {
  if (path === '/') {
    return createTeamConfig(TEAMS.ProductDataManagement)
  }

  path = path.split(/[?#]/)[0]

  const matchingRoute = Object.keys(TEAM_ROUTING_CONFIG).find((route) => {
    return path === route || path.startsWith(route + '/')
  })
  const defaultTeam = createTeamConfig(TEAMS.Unknown)

  return matchingRoute ? TEAM_ROUTING_CONFIG[matchingRoute] : defaultTeam
}

export const setTeamTagForPath = (path) => {
  const team = getTeamForRoute(path)
  datadogRum.setGlobalContextProperty('team', team.team)
  datadogRum.setGlobalContextProperty('tribe', team.tribe)
}
